// The Landing component will be used on the homepage only and will be accompanied by an animation.
import '../style/landing.css';
import NavButton from '../components/NavButton.js';
import { useState, useEffect } from 'react';

function Landing() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const backgroundImage = new Image();
        backgroundImage.src = require('../resources/meyers-background.png');
        backgroundImage.onload = () => setIsLoaded(true);
    }, []);

    return (
        <>
            <div class='landing-wrapper'>
                <div class={`landing-content ${isLoaded ? 'loaded' : 'loading'}`}>
                    <div class={`landing-overlay ${isLoaded ? 'show' : 'hide'}`}>
                        <div class='inner-landing-overlay'>
                            <h1>Borealis Blades Historical Fencing</h1>
                            <section>
                                <p>
                                    Welcome to Borealis Blades Historical Fencing. 
                                    <br /><br/>
                                    We are a non-profit HEMA club located in and around the Duluth Area. 
                                    Borealis Blades is an official HEMAA affiliated club. Our main goal in this community is to: 
                                    <br />
                                    <b>“Get more people doing more HEMA.”</b>
                                </p>
                            </section>
                            <div className='landing-nav'>
                                {/*Events page is commented out until needed, don't forget to uncomment in Header.js*/}
                                {/*<NavButton url='/events' value='Events' />*/}
                                <NavButton url='/faq' value='FAQ' />
                                <NavButton url='/gallery' value='Gallery' />
                                <NavButton url='/join' value='Join Us' />
                                <NavButton url='/our-story' value='Our Story' />
                                <NavButton url='/resources' value='Resources' />
                            </div>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Landing;